import React, { useRef } from 'react';
import { BiFolderOpen } from 'react-icons/bi';
import ButtonSecondary from '../ButtonSecondary/view';
import './style.css';

const InputDirectory = ({ onFilesSelected, label = "Seleccionar Carpeta", disabled = false, mode = "folder", icon = <BiFolderOpen size={20} /> }) => {
    const inputRef = useRef(null);

    const handleChange = (e) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            // MUST copy the FileList to an array because setting e.target.value = '' 
            // will mutate the original FileList and empty it out.
            const fileArray = Array.from(files);
            onFilesSelected(fileArray);
        }
        // Reset value to allow selecting same folder again if needed
        e.target.value = '';
    };

    const handleClick = () => {
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    return (
        <div className="input-directory-container">
            <input
                type="file"
                ref={inputRef}
                style={{ display: 'none' }}
                multiple={mode === 'files' ? true : undefined}
                webkitdirectory={mode === 'folder' ? "true" : undefined}
                directory={mode === 'folder' ? "true" : undefined}
                onChange={handleChange}
                disabled={disabled}
            />
            <ButtonSecondary
                onClick={handleClick}
                disabled={disabled}
                icon={icon}
                title={label}
            />
        </div>
    );
};

export default InputDirectory;
